import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-018ffe7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistic-page" }
const _hoisted_2 = { class: "statistic-page__header" }
const _hoisted_3 = { class: "statistic-page__header--left-block" }
const _hoisted_4 = { class: "statistic-page__title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Показатели ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Диаграммы ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Пациенты ")
const _hoisted_8 = { class: "indicators-statistic" }
const _hoisted_9 = { class: "indicators-statistic__header" }
const _hoisted_10 = { class: "indicators-statistic__date-picker" }

import { computed, onMounted, onUpdated, ref, watch } from 'vue'
import ru from 'element-plus/es/locale/lang/ru'
import { useUser } from '@/shared/composables'
import { WIndicatorsStatistic } from '@/widgets/WIndicatorsStatistic'
import { WIndicatorsStatisticPatients } from '@/widgets/WIndicatorsStatisticPatients'
import IndicatorsStatisticTariffs from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatisticTariffs.vue'
import IndicatorsStatisticTable from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatisticTable.vue'
import {
  APPOINTMENTS_MODE,
  FILTER_MODE,
} from '@/widgets/WIndicatorsStatistic/constants/mode'
import {
  getDateFormat,
  getFirstDayOfMonth,
  getLastDayOfMonth,
  showErrorMessage,
} from '@/shared/utils'
import { statisticApi } from '@/shared/api'
import { REPORT_VIEW, DATE_FORMAT } from '@/shared/constants'
import {
  ReportViewType,
  StatisticAppointmentType,
  StatisticAppointmentTypeWithPatients,
  StatisticDoctorType,
  StatisticFilterType,
  StatisticReportType,
} from '@/shared/types'
import { FilterModeType } from '@/widgets/WIndicatorsStatistic/types/mode.type'
import { PAGE_MODE } from './constants/mode'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser()

const additionalTariffPanelLines = computed(
  (): Object =>
    new Object({
      'Пациенты в боте:': botPatientCount,
      'Пациенты:': totalPatientCount,
    })
)

const showMyPatients = ref(false)
const pageMode = ref(PAGE_MODE.statistics)
const filterMode = ref(FILTER_MODE.month)
const month = ref(getFirstDayOfMonth(new Date()))
const dateRange = ref([])
const reportType = ref<ReportViewType>(REPORT_VIEW.plaqueIndex)

const doctors = ref<StatisticDoctorType[]>([])
const reports = ref<StatisticReportType[]>([])
const screenings = ref<StatisticReportType[]>([])
const brushmaps = ref<StatisticReportType[]>([])
const periodontologies = ref<StatisticReportType[]>([])
const timelyAppointments = ref<StatisticAppointmentType[]>([])
const appointments = ref<StatisticAppointmentType[]>([])
const botPatientCount = ref(0)
const totalPatientCount = ref(0)
const summary = ref<StatisticDoctorType>()

const selectedDoctor = ref<StatisticDoctorType>(null)
const plannedPatients = ref<StatisticAppointmentTypeWithPatients[]>([])

const currentReports = computed(() => {
  switch (reportType.value) {
    case REPORT_VIEW.brushMap:
      return brushmaps.value
    case REPORT_VIEW.screening:
      return screenings.value
    case REPORT_VIEW.periodontal:
      return periodontologies.value
    case REPORT_VIEW.plaqueIndex:
      return reports.value
    case APPOINTMENTS_MODE.planned:
      return appointments.value
    case APPOINTMENTS_MODE.timely:
      return timelyAppointments.value
  }

  return timelyAppointments.value
})

onMounted((): void => updateStatisticsAndPatients(filterMode.value))

watch(filterMode, (): void => updateStatisticsAndPatients(filterMode.value))
watch(month, (): void => updateStatisticsAndPatients(filterMode.value))
watch(dateRange, (): void => updateStatisticsAndPatients(filterMode.value))

const updateStatisticsAndPatients = (filterMode: FilterModeType) => {
  getStatistic(filterMode)
  getPatients(filterMode)
}

const getStatistic = async (mode: FilterModeType): Promise<void> => {
  if (
    mode === 'date' &&
    Object.values(APPOINTMENTS_MODE).includes(reportType.value)
  ) {
    reportType.value = REPORT_VIEW.plaqueIndex
  }

  const filter: StatisticFilterType = setFilterByMode(mode)

  const [error, response] = await statisticApi.getDoctorStatistic(filter)

  if (error) {
    showErrorMessage(error)

    return
  }

  doctors.value = response.data.doctors
  timelyAppointments.value = response.data.timelyAppointments
  appointments.value = response.data.appointments
  reports.value = response.data.reports
  brushmaps.value = response.data.brushmaps
  screenings.value = response.data.screenings
  periodontologies.value = response.data.periodontologies
  botPatientCount.value = response.data.botPatientCount
  totalPatientCount.value = response.data.totalPatientCount
  summary.value = response.data.summary
}

const getPatients = async (mode: FilterModeType): Promise<void> => {
  const filter: StatisticFilterType = setFilterByMode(mode)

  const [error, response] = await statisticApi.getPatientsStatistic(filter)

  if (error) {
    showErrorMessage(error)

    return
  }

  plannedPatients.value = response.data.visits_plan
}

const setFilterByMode = (mode: FilterModeType): StatisticFilterType => {
  const filter: StatisticFilterType = {
    dateFrom: undefined,
    dateTo: undefined,
  }

  switch (mode) {
    case FILTER_MODE.date: {
      filter.dateFrom = dateRange.value ? dateRange.value[0] : []
      filter.dateTo = dateRange.value ? dateRange.value[1] : []
      break
    }
    case FILTER_MODE.month: {
      filter.dateFrom = new Date(
        getDateFormat(month.value, DATE_FORMAT.ymdDash)
      )
      filter.dateTo = getLastDayOfMonth(month.value)
      break
    }
  }

  return filter
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(user).organization.name), 1),
        _createVNode(_component_el_button_group, { class: "header__button" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (pageMode.value = _unref(PAGE_MODE).statistics)),
              size: "small",
              type: pageMode.value === _unref(PAGE_MODE).statistics ? 'primary' : '',
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (pageMode.value = _unref(PAGE_MODE).chart)),
              size: "small",
              type: pageMode.value === _unref(PAGE_MODE).chart ? 'primary' : '',
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (pageMode.value = _unref(PAGE_MODE).patients)),
              size: "small",
              type: pageMode.value === _unref(PAGE_MODE).patients ? 'primary' : '',
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["type"])
          ]),
          _: 1
        })
      ]),
      _createVNode(IndicatorsStatisticTariffs, { "additional-lines": _unref(additionalTariffPanelLines) }, null, 8, ["additional-lines"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_select, {
          modelValue: filterMode.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterMode).value = $event)),
          class: "indicators-statistic__date-mode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: _unref(FILTER_MODE).date,
              label: "Выбрать даты"
            }, null, 8, ["value"]),
            _createVNode(_component_el_option, {
              value: _unref(FILTER_MODE).month,
              label: "Помесячно"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_10, [
          (filterMode.value === _unref(FILTER_MODE).month)
            ? (_openBlock(), _createBlock(_component_el_config_provider, {
                key: 0,
                locale: _unref(ru)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: month.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((month).value = $event)),
                    format: "MMMM, YYYY",
                    type: "month"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["locale"]))
            : (_openBlock(), _createBlock(_component_el_config_provider, {
                key: 1,
                locale: _unref(ru)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: dateRange.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dateRange).value = $event)),
                    "end-placeholder": "Конец",
                    format: "DD.MM.YYYY",
                    "start-placeholder": "Начало",
                    type: "daterange",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["locale"]))
        ]),
        (pageMode.value === _unref(PAGE_MODE).chart)
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: reportType.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((reportType).value = $event)),
              class: "indicators-statistic__date-mode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  value: _unref(REPORT_VIEW).plaqueIndex,
                  label: "Индекс налёта"
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  value: _unref(REPORT_VIEW).periodontal,
                  label: "Пародонтология"
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  value: _unref(REPORT_VIEW).screening,
                  label: "Скрининг"
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  value: _unref(REPORT_VIEW).brushMap,
                  label: "Карта ёршиков"
                }, null, 8, ["value"]),
                (filterMode.value === _unref(FILTER_MODE).month)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_option, {
                        value: _unref(APPOINTMENTS_MODE).timely,
                        label: "Пришедшие"
                      }, null, 8, ["value"]),
                      _createVNode(_component_el_option, {
                        value: _unref(APPOINTMENTS_MODE).planned,
                        label: "Планируемые"
                      }, null, 8, ["value"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (pageMode.value === _unref(PAGE_MODE).patients)
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              placeholder: "Врач",
              modelValue: selectedDoctor.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedDoctor).value = $event)),
              "value-key": "id",
              clearable: "",
              class: "indicators-statistic__date-mode__wide"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctors.value, (doctor) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: doctor,
                    label: doctor.name
                  }, null, 8, ["value", "label"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      (pageMode.value === _unref(PAGE_MODE).statistics)
        ? (_openBlock(), _createBlock(IndicatorsStatisticTable, {
            key: 0,
            "table-props-data": doctors.value,
            summary: summary.value
          }, null, 8, ["table-props-data", "summary"]))
        : _createCommentVNode("", true),
      (pageMode.value === _unref(PAGE_MODE).chart)
        ? (_openBlock(), _createBlock(_unref(WIndicatorsStatistic), {
            key: 1,
            reports: _unref(currentReports),
            doctors: doctors.value,
            "report-type": reportType.value
          }, null, 8, ["reports", "doctors", "report-type"]))
        : _createCommentVNode("", true),
      (pageMode.value === _unref(PAGE_MODE).patients)
        ? (_openBlock(), _createBlock(_unref(WIndicatorsStatisticPatients), {
            key: 2,
            patients: plannedPatients.value,
            "selected-doctor": selectedDoctor.value,
            showMyPatients: showMyPatients.value
          }, null, 8, ["patients", "selected-doctor", "showMyPatients"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})